class NumberValid {
    constructor(c = {}) {
        this.input = c.input
        this.init()
    }
    init() {
        this.listenerInput()
    }
    listenerInput() {
        this.input.addEventListener('input', e => {
            this.handlerInput(e)
        })
    }
    handlerInput(e) {
        this.input.value = e.currentTarget.value.replace(/[^.\d]+/g, "").replace(/^([^\.]*\.)|\./g, '$1')
    }
}

let inputNumberValid = document.querySelectorAll('[data-number-valid]')
if (inputNumberValid.length > 0) {
    for (let i = 0; i < inputNumberValid.length; i++) {
        new NumberValid({ input: inputNumberValid[i] })
    }
}